export const overlay = document.getElementById('theme-overlay')
export const hamburgerButton = document.getElementById('js-hamburger-button')
export const menuPrimary = document.getElementById('js-menu-primary')
export const menuParentItems = document.querySelectorAll(
	'.c-menu__link[aria-expanded]'
)

const MQ_MENU = '(min-width: 950px)'
export const mqMenu = window.matchMedia(MQ_MENU)

export const themeButtons = document.querySelectorAll(
	'#js-theme-switcher .js-theme-option'
)
export const popupToggles = document.querySelectorAll('.js-popup-toggle')
export const popups = document.querySelectorAll('.js-popup')
export const fullBleedEls = document.querySelectorAll('.u-full-bleed')
export const spacesMediaNavigation = document.querySelectorAll(
	'.js-spaces-media-navigation'
)
export const searchInput = document.querySelector('.facetwp-search')
export const stickyEls = document.querySelectorAll('.js-sticky')
export const calendarPopup = document.querySelector('.js-calendar-popup')
export const calendarEvents = document.querySelectorAll('.calendar-day')
export const calendars = document.querySelectorAll('.js-calendar')
export const calendarCloseItems = document.querySelectorAll('.js-popup-close')
const MQ_CALENDAR = '(max-width: 900px)'
export const mqCalendar = window.matchMedia(MQ_CALENDAR)
